import { Alert, Button, Checkbox, ConfigProvider, Modal, Typography } from 'antd'
import { useContext, useEffect, useState } from 'react'
import { AuthenticationContext } from '../../AuthenticationContext'
import { useAcceptTermsMutation, useTermsCheck } from './termsQueries'

const TERMS_LINK = 'https://synkedup.com/terms-conditions/'
const BRAND_ORANGE = '#FF5C35'

const titleStyle = {
  marginTop: 0,
  fontFamily: 'inherit',
  fontWeight: 700,
  textTransform: 'none' as const
}

const TermsAcceptanceGate = () => {
  const { currentUser } = useContext(AuthenticationContext)
  const [agreed, setAgreed] = useState(false)
  const isAuthenticated = !!currentUser
  const termsCheckQuery = useTermsCheck(isAuthenticated)
  const acceptTermsMutation = useAcceptTermsMutation()

  const needsAcceptance = termsCheckQuery.data?.needsAcceptance ?? false
  const changeDescription = termsCheckQuery.data?.changeDescription ?? ''

  useEffect(() => {
    if (needsAcceptance) {
      setAgreed(false)
    }
  }, [needsAcceptance, changeDescription])

  if (!isAuthenticated || !needsAcceptance) {
    return null
  }

  const handleContinue = () => {
    acceptTermsMutation.mutate(undefined, {
      onError: () => setAgreed(false)
    })
  }

  return <ConfigProvider theme={{ token: { colorPrimary: BRAND_ORANGE, colorLink: BRAND_ORANGE, colorLinkHover: BRAND_ORANGE, colorLinkActive: BRAND_ORANGE } }}>
    <Modal
      open={true}
      closable={false}
      keyboard={false}
      maskClosable={false}
      footer={null}
      width={720}
      title={null}
    >
      <Typography.Title level={2} style={titleStyle}>
        Updated Terms & Conditions
      </Typography.Title>
      <Typography.Paragraph>
        We've made some updates to our{' '}
        <Typography.Link href={TERMS_LINK} target="_blank" rel="noopener noreferrer">
          Terms and Conditions
        </Typography.Link>
        . By checking the box below, you confirm that you've read and agree to the updated terms.
      </Typography.Paragraph>
      {changeDescription && (
        <Alert
          type="info"
          showIcon={true}
          description={changeDescription}
          style={{ marginBottom: 16 }}
        />
      )}
      <Checkbox checked={agreed} onChange={(e) => setAgreed(e.target.checked)}>
        <span style={{ fontWeight: 'normal' }}>I agree to the Terms & Conditions</span>
      </Checkbox>
      {acceptTermsMutation.isError && (
        <Alert
          type="error"
          showIcon={true}
          message="Unable to record your acceptance. Please try again."
          style={{ marginTop: 16 }}
        />
      )}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
        <Button
          type="primary"
          onClick={handleContinue}
          disabled={!agreed || acceptTermsMutation.isLoading}
          loading={acceptTermsMutation.isLoading}
        >
          Continue
        </Button>
      </div>
    </Modal>
  </ConfigProvider>
}

export default TermsAcceptanceGate
